<template>
    <div class="detail-item">
        <b-modal ref="my-modal" hide-footer>
            <template slot="modal-title">
                <span class="text-danger">{{langPostDetailPage.error[locale]}}</span>
            </template>
            <div class="d-block text-center">
                <b-alert variant="danger" show>{{errorModalText}}</b-alert>
            </div>
        </b-modal>
        <video-image-modal/>
        <div class="container" v-if="loading">
            <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
        </div>
        <div class="content-wrapper" v-else-if="statusOk && item">
            <div class="btn-wrapper row" v-if="authenticatedUserID === item.user._id">
                <div class="col">
                    <button style="margin: 5px;" type="button" class="btn" :class="item.status === 'sold' ? 'btn-secondary':'btn-outline-primary'" @click.stop="markAsSold" :disabled="item.status === 'sold'">
                        <span v-if="item.status !== 'sold'">
                            {{langPostDetailPage.markAsSold[locale]}} <font-awesome-icon icon="circle-notch" :spin="true" v-if="markingAsSold" /><font-awesome-icon icon="hammer" v-else />
                        </span>
                        <span v-else>
                            {{langPostDetailPage.sold[locale]}}
                        </span>
                    </button>
                </div>
                <div class="col">
                    <router-link v-if="item.status !== 'sold'" style="margin: 5px;" :to="`/post/${item._id}/edit`" class="btn btn-outline-dark">
                        {{langPostDetailPage.edit[locale]}} <font-awesome-icon icon="edit"/>
                    </router-link>
                </div>
                <div class="col">
                    <button style="margin: 5px;" type="button" class="btn btn-outline-danger" @click.stop="deletePost">
                        {{langPostDetailPage.delete[locale]}} <font-awesome-icon icon="circle-notch" :spin="true" v-if="deleting" /><font-awesome-icon icon="times-circle" v-else />
                    </button>
                </div>
            </div>
            <b-carousel style="box-shadow: 0px 0px 1px 1px #888888;" controls indicators fade background="#ababab" :interval="0" img-width="1024" img-height="480">
                <b-carousel-slide v-for="(uri, i) in item.imageURIs" :key="i+uri">
                    <div slot="img" :style="`background-image: url(${uri}); height: 480px; background-repeat: no-repeat; background-size: contain; background-color: rgba(0,0,0,0); background-position: center;`"></div>                   
                </b-carousel-slide>
            </b-carousel>
            <div class="container item-thumbnails dragscroll">
                <div class="video" v-for="(uri, n) in item.videoURIs" v-bind:key="n" v-on:click.stop="showVideo({videoURI: uri})">
                    <video :src="uri"></video>
                    <img class="video-play-icon" src="../assets/upload.png" />
                </div>
            </div>
            <social-sharing :url="SocialShareURL" :title="item.name" :description="item.description" :quote="item.name" hashtags="nettipyöra,nettopyora" twitter-user="nettipyöra" v-cloak inline-template>
                <div class="networks" style="font-size: 15px">
                    <network style="padding-left: 2px; padding-right: 2px; border-radius: 5px; margin: 2px; cursor: pointer; background: #3B5998; color: white;" network="facebook">
                        <font-awesome-icon :icon="['fab', 'facebook']"/> Facebook
                    </network>
                    <network style="padding-left: 2px; padding-right: 5px; border-radius: 5px; margin: 2px; cursor: pointer; background: #007bb5; color: white;" network="linkedin">
                        <font-awesome-icon :icon="['fab', 'linkedin']"/> LinkedIn
                    </network>
                    <network style="padding-left: 2px; padding-right: 2px; border-radius: 5px; margin: 2px; cursor: pointer; background: #55ACEE; color: white;" network="twitter">
                        <font-awesome-icon :icon="['fab', 'twitter']"/> Twitter
                    </network>
                    <network style="padding-left: 2px; padding-right: 2px; border-radius: 5px; margin: 2px; cursor: pointer; background: #25D366; color: white;" network="whatsapp">
                        <font-awesome-icon :icon="['fab', 'whatsapp']"/> WhatsApp
                    </network>
                </div>
            </social-sharing>
            <br />
            <br />
            <div class="container item-detail-info">
                <h1 class="text-left">{{item.title}} <span v-if="item.status !== 'selling'" :class="{'text-info': item.status === 'sold', 'text-danger': item.status === 'canceled'}" style="text-transform: uppercase; font-weight: 100">[{{langPostDetailPage[item.status][locale]}}]</span> <div class="created-at-text text-muted" style="margin-top: 5px; margin-left: 5px"> <font-awesome-icon :icon="'calendar-alt'"/>{{` ${new Date(item.createdAt).getDate()}-${new Date(item.createdAt).getMonth()}-${new Date(item.createdAt).getFullYear()}`}}</div></h1>
                <p class="text-left text-muted">{{item.description}}</p>
                <div class="row">
                    <div class="table-responsive" :class="{col: !smallViewPort}">
                        <table class="table text-left">
                            <tbody>
                                <tr v-if="item.currentPrice > -1 && (item.status === 'selling' || item.user._id === authenticatedUserID)">
                                    <th>{{langPostDetailPage.price[locale]}}</th>
                                    <td>
                                        <strike v-if="item.oldPrice"><small>€{{item.oldPrice}}</small></strike>
                                        <kbd>€{{item.currentPrice}}</kbd>
                                    </td>
                                </tr>
                                <tr v-if="item.city && item.province && item.country">
                                    <th>{{langPostDetailPage.location[locale]}}</th>
                                    <td>{{item.city}}, {{item.province}}, {{item.country}}</td>
                                </tr>
                                <tr v-if="item.user.address">
                                    <th>{{langPostDetailPage.address[locale]}}</th>
                                    <td>{{item.user.address}}</td>
                                </tr>
                                <tr>
                                    <th>{{langPostDetailPage.seller[locale]}}</th>
                                    <td>
                                        <router-link class="text-primary" :to="'/user/'+item.user._id">{{item.user.name}}</router-link>
                                        <small class="item-store-tag" v-if="item.user.role === 'store'">{{langPostDetailPage.store[locale]}}</small>
                                    </td>
                                </tr>
                                <tr v-if="item.user.website">
                                    <th>{{langPostDetailPage.website[locale]}}</th>
                                    <td><a :href="item.user.website" target="_blank">{{item.user.website}}</a></td>
                                </tr>
                                <tr>
                                    <th>{{langPostDetailPage.contacts[locale]}}</th>
                                    <td v-if="showContacts.indexOf('main') > -1">
                                        <a class="text-primary" :href="`mailto:${item.user.email}?Subject=${item.name}[nettipyora.fi]&Body=${'Hi'+',%0D%0A  %0D%0A'+SocialShareURL+' ['+item.description}]`" target="_top">
                                            {{item.user.email}}
                                        </a> 
                                        <span class="text-center" style="width: 1rem; display: inline-block"> | </span>
                                        <a class="text-primary" :href="'tel:'+item.user.phone">
                                            {{item.user.phone}}
                                        </a>
                                    </td>
                                    <td v-else>
                                        <button class="btn btn-primary" v-on:click.stop="toggleShowContact('main')">{{langPostDetailPage.showContact[locale]}}</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-responsive" :class="{col: !smallViewPort}">
                        <table class="table text-left">
                            <tbody>
                                <tr>
                                    <th>{{langPostDetailPage.condition[locale]}}</th>
                                    <td class="text-muted text-left">
                                        <div style="font-size: 0.8em">
                                            <strong>{{conditionText}}</strong>
                                            <ConditionBar style="display: block" :value="item.condition"/>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="item.type">
                                    <th>{{langPostDetailPage.type[locale]}}</th>
                                    <td>{{item.type[locale]}}</td>
                                </tr>
                                <tr v-if="item.maker">
                                    <th>{{langPostDetailPage.maker[locale]}}</th>
                                    <td>{{item.maker[locale]}}</td>
                                </tr>
                                <tr v-if="item.subType">
                                    <th>{{langPostDetailPage.subType[locale]}}</th>
                                    <td>{{item.subType[locale]}}</td>
                                </tr>
                                <tr v-if="item.frameSize">
                                    <th>{{langPostDetailPage.frameSize[locale]}}</th>
                                    <td>{{item.frameSize[locale]}}</td>
                                </tr>
                                <tr v-if="item.gears">
                                    <th>{{langPostDetailPage.gears[locale]}}</th>
                                    <td>{{item.gears[locale]}}</td>
                                </tr>
                                <tr v-if="item.material">
                                    <th>{{langPostDetailPage.material[locale]}}</th>
                                    <td>{{item.material[locale]}}</td>
                                </tr>
                                <tr v-if="item.breakType">
                                    <th>{{langPostDetailPage.breakType[locale]}}</th>
                                    <td>{{item.breakType[locale]}}</td>
                                </tr>
                                <tr v-if="item.suspensionType">
                                    <th>{{langPostDetailPage.suspensionType[locale]}}</th>
                                    <td>{{item.suspensionType[locale]}}</td>
                                </tr>
                                <tr v-if="item.gender">
                                    <th>{{langPostDetailPage.gender[locale]}}</th>
                                    <td>{{item.gender[locale]}}</td>
                                </tr>
                                <tr v-if="item.numOfWheels">
                                    <th>{{langPostDetailPage.numOfWheels[locale]}}</th>
                                    <td>{{item.numOfWheels[locale]}}</td>
                                </tr>
                                <tr v-if="item.wheelSize">
                                    <th>{{langPostDetailPage.wheelSize[locale]}}</th>
                                    <td>{{item.wheelSize[locale]}}</td>
                                </tr>
                                <tr v-if="item.tyreType">
                                    <th>{{langPostDetailPage.tyreType[locale]}}</th>
                                    <td>{{item.tyreType[locale]}}</td>
                                </tr>
                                <tr v-if="item.mudGuardType">
                                    <th>{{langPostDetailPage.mudGuardType[locale]}}</th>
                                    <td>{{item.mudGuardType[locale]}}</td>
                                </tr>
                                <tr v-if="item.rackType">
                                    <th>{{langPostDetailPage.rackType[locale]}}</th>
                                    <td>{{item.rackType[locale]}}</td>
                                </tr>
                                <tr v-if="item.basketType">
                                    <th>{{langPostDetailPage.basketType[locale]}}</th>
                                    <td>{{item.basketType[locale]}}</td>
                                </tr>
                                <tr v-if="item.lockIncluded === true || item.lockIncluded === false">
                                    <th>{{langPostDetailPage.isLockIncluded[locale]}}</th>
                                    <td v-if="item.lockIncluded">{{langPostDetailPage.yes[locale]}}</td>
                                    <td v-else-if="item.lockIncluded === false">{{langPostDetailPage.no[locale]}}</td>
                                </tr>
                                <tr v-if="item.frontLightIncluded === true || item.frontLightIncluded === false">
                                    <th>{{langPostDetailPage.isFrontLightIncluded[locale]}}</th>
                                    <td v-if="item.frontLightIncluded">{{langPostDetailPage.yes[locale]}}</td>
                                    <td v-else-if="item.frontLightIncluded === false">{{langPostDetailPage.no[locale]}}</td>
                                </tr>
                                <tr v-if="item.rareLightIncluded === true || item.rareLightIncluded === false">
                                    <th>{{langPostDetailPage.isRareLightIncluded[locale]}}</th>
                                    <td v-if="item.rareLightIncluded">{{langPostDetailPage.yes[locale]}}</td>
                                    <td v-else-if="item.rareLightIncluded === false">{{langPostDetailPage.no[locale]}}</td>
                                </tr>
                                <tr v-if="item.legStandExists === true || item.legStandExists === false">
                                    <th>{{langPostDetailPage.legStandExists[locale]}}</th>
                                    <td v-if="item.legStandExists">{{langPostDetailPage.yes[locale]}}</td>
                                    <td v-else-if="item.legStandExists === false">{{langPostDetailPage.no[locale]}}</td>
                                </tr>
                                <tr v-if="item.color">
                                    <th>{{langPostDetailPage.color[locale]}}</th>
                                    <td><span :style="`color: ${item.color.toLowerCase()}`">{{item.color}}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <div class="container table-responsive" v-if="item.user.role === 'store' && (item.user.contacts ? item.user.contacts.length>0 : false)">
                <h4>{{langPostDetailPage.storeContacts[locale]}}</h4>
                <table class="table text-left">
                    <thead>
                        <tr>
                            <th scope="col">{{langPostDetailPage.name[locale]}}</th>
                            <th scope="col">{{langPostDetailPage.contact[locale]}}</th>
                            <th scope="col">{{langPostDetailPage.languages[locale]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(contact, i) in item.user.contacts" :key="i">
                            <td>{{contact.name}}</td>
                            <td v-if="showContacts.indexOf(i) > -1">
                                <a :href="`mailto:${contact.email}?Subject=${item.name}[nettipyora.fi]&Body=${'hi'+',%0D%0A  %0D%0A'+SocialShareURL+' ['+item.description}]`" target="_top">
                                    {{contact.email}}
                                </a> 
                                <span class="text-center" style="width: 1rem; display: inline-block" v-if="contact.email && contact.phone"> | </span>
                                <a :href="'tel:'+contact.phone">
                                    {{contact.phone}}
                                </a>
                            </td>
                            <td v-else>
                                <button class="btn btn-primary" v-on:click.stop="toggleShowContact(i)">{{langPostDetailPage.showContact[locale]}}</button>
                            </td>
                            <td>
                                <span class="language-tag" v-for="(l, n) in contact.languages" :key="n">{{l}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="container" v-else-if="statusOk && !item">
            <strong class="no-post">{{langPostDetailPage.postNotFound[locale]}}</strong>
        </div>
        <div class="container" v-else-if="!statusOk">
            <b-alert class="error-post" show variant="danger" v-if="statusOk === false && errMessage">{{errMessage}}</b-alert>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import VideoImageModal from "@/components/VideoImageModal";
import langPostDetailPage from '@/store/lang/postDetailPage';
import ConditionBar from '@/components/ConditionBar';

export default {
    name: "PostDetail",
    components: {
        VideoImageModal, ConditionBar
    },
    data () {
        return {
            langPostDetailPage,
            SocialShareURL: '',
            smallViewPort: false,
            showContacts: []
        }
    },
    computed: { 
        ...mapState({
            loading: state => state.PostDetail.loading,
            statusOk: state => state.PostDetail.statusOk,
            okMessage: state => state.PostDetail.okMessage,
            errMessage: state => state.PostDetail.errMessage,
            item: state => state.PostDetail.post,
            markingAsSold: state => state.PostDetail.markingAsSold,
            //markingAsSelling: state => state.PostDetail.markingAsSelling,
            deleting: state => state.PostDetail.deleting,
            errorModalText: state => state.PostDetail.errorModalText,
            authenticatedUserID: state => state.authenticatedUserID,
            locale: state => state.locale,
            filters: state => state.filters
        }),
        conditionText() {
            let value = "";
            this.filters[this.locale].selectCondtionOptions.forEach(item => {
                if(item.value === this.item.condition) value = item.text;
            });
            return value;
        }
    },
    created() {
        this.SocialShareURL = window.location.href;
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        markAsSold() {
            this.$store.dispatch('POST_DETAIL_MARK_AS_SOLD', this.item._id).catch(() => {
                this.$refs['my-modal'].show()
            });
        },/*
        markAsSelling() {
            this.$store.dispatch('POST_DETAIL_MARK_AS_SELLING', this.item._id).catch(() => {
                this.$refs['my-modal'].show()
            });
        },*/
        deletePost() {
            this.$store.dispatch('POST_DETAIL_DELETE', this.item._id).catch(() => {
                this.$refs['my-modal'].show()
            });
        },
        showVideo(param) {
            this.$modal.show('video-image-modal', param);
        },
        handleResize() {
            this.smallViewPort = window.innerWidth <= 600;
        },
        toggleShowContact(key) {
            const i = this.showContacts.indexOf(key);
            if(i > -1) {
                this.showContacts.splice(i, 1);
            } else this.showContacts.push(key);
        }
    },
    mounted() {
        const draggableScript = document.createElement('script');
		draggableScript.type = 'text/javascript';
		draggableScript.text = `!function(e,n){"function"==typeof define&&define.amd?define(["exports"],n):"undefined"!=typeof exports?n(exports):n(e.dragscroll={})}(this,function(e){var n,t,o=window,l=document,c="mousemove",r="mouseup",i="mousedown",m="EventListener",d="add"+m,s="remove"+m,f=[],u=function(e,m){for(e=0;e<f.length;)(m=(m=f[e++]).container||m)[s](i,m.md,0),o[s](r,m.mu,0),o[s](c,m.mm,0);for(f=[].slice.call(l.getElementsByClassName("dragscroll")),e=0;e<f.length;)!function(e,m,s,f,u,a){(a=e.container||e)[d](i,a.md=function(n){e.hasAttribute("nochilddrag")&&l.elementFromPoint(n.pageX,n.pageY)!=a||(f=1,m=n.clientX,s=n.clientY,n.preventDefault())},0),o[d](r,a.mu=function(){f=0},0),o[d](c,a.mm=function(o){f&&((u=e.scroller||e).scrollLeft-=n=-m+(m=o.clientX),u.scrollTop-=t=-s+(s=o.clientY),e==l.body&&((u=l.documentElement).scrollLeft-=n,u.scrollTop-=t))},0)}(f[e++])};"complete"==l.readyState?u():o[d]("load",u,0),e.reset=u});`;
        document.head.appendChild(draggableScript);
        this.$store.dispatch('POST_DETAIL_FETCH', this.$route.params.postID);
    }
};
</script>

<style scoped>
.no-post, .spinner, .error-post {
    margin: 2em;
}
.no-post {
    display: block;
}
.item-image {
    position: relative;
    width: 1000px;
    height: 500px;
    margin: auto;
}
@media only screen and (max-width: 1200px) {
    .item-image {
        position: relative;
        width: 700px;
        height: 350px;
        margin: auto;
    }
}
@media only screen and (max-width: 1000px) {
    .item-image {
        position: relative;
        width: 600px;
        height: 300px;
        margin: auto;
    }
}
@media only screen and (max-width: 800px) {
    .item-image {
        position: relative;
        width: 500px;
        height: 250px;
        margin: auto;
    }
}
@media only screen and (max-width: 600px) {
    .item-image {
        position: relative;
        width: 300px;
        height: 150px;
        margin: auto;
    }
}
#showing-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: rgba(0,0,0,0.2);
    background-position: center;
    border: 1px solid lightgray;
}
.item-thumbnails {
    overflow-x: auto;
    white-space: nowrap;
}

.video {
    position: relative;
    height: 100px;
    width: 150px;
    margin: 5px;
    display: inline-block;
    cursor: pointer;
}

.video-play-icon {
    position: absolute;
    left: 39px;
    top: 14px;
}

video {
    height: 100px;
    width: 150px;
    border-radius: 1em;
    border: 1px solid darkgray;
}
.thumbnail {
    display: inline-block;
    float: none;
    background-color: rgba(0,0,0,0.3);
    width: 100px;
    height: 80px;
    opacity: 0.4;
    margin: 5px;
    border: 1px solid gray;
    cursor: pointer;
}
.networks {
    font-size: 1.25em;
    margin-top: 5px;
}
.active {
    opacity: 1;
}
.created-at-text {
    font-size: 0.3em;
}
strike {
    margin: 2px;
}
.item-store-tag {
    padding-left: 5px;
    padding-right: 5px;
    margin-left: 5px;
    margin-right: 5px;
    background: gray;
    border-radius: 2px;
    color: white;
}
.language-tag {
    padding-left: 5px;
    padding-right: 5px;
    background: gray;
    border-radius: 2px;
    color: white;
    margin: 2px;
}
</style>